{
 "title": {
  "x": 198,
  "y": 298,
  "w": 550,
  "h": 62,
  "lane": {
   "x": 198,
   "y": 298,
   "w": 550,
   "h": 62
  }
 },
 "hint": {
  "x": 194,
  "y": 1095,
  "w": 555,
  "h": 33,
  "lane": {
   "x": 180,
   "y": 1086,
   "w": 584,
   "h": 48
  }
 },
 "share": {
  "x": 390,
  "y": 1182,
  "w": 160,
  "h": 47,
  "lane": {
   "x": 300,
   "y": 1170,
   "w": 340,
   "h": 70
  }
 },
 "save": {
  "x": 268,
  "y": 1308,
  "w": 78,
  "h": 29,
  "lane": {
   "x": 180,
   "y": 1288,
   "w": 260,
   "h": 66
  }
 },
 "copy": {
  "x": 556,
  "y": 1309,
  "w": 167,
  "h": 30,
  "lane": {
   "x": 500,
   "y": 1288,
   "w": 270,
   "h": 66
  }
 }
}